module.exports = __webpack_public_path__ + "img/ecoleSuperU.25a13968.jpg";